export const MAINTENANCE_BANNER_DISMISSED_KEY = 'maintenance-banner-ets-migration-downtime-sept-2026-dismissed';

// Banner: 11 Sep 2026 09:00 CEST → 14 Sep 2026 08:00 CEST
export const MAINTENANCE_BANNER_START = new Date('2026-09-11T09:00:00+02:00');
export const MAINTENANCE_BANNER_END = new Date('2026-09-14T08:00:00+02:00');

// Deployment window: 19 Aug 2026 17:00 CEST → 20 Aug 2026 00:00 CEST
export const DEPLOYMENT_WINDOW_START = new Date('2026-08-19T17:00:00+02:00');
export const DEPLOYMENT_WINDOW_END = new Date('2026-08-20T00:00:00+02:00');
